module.exports = __webpack_public_path__ + "img/q-10-1@2x.ee26baa3.png";